/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, memo, useMemo } from 'react'
import {
  View,
  ScrollView,
  Platform,
  TouchableOpacity,
  Dimensions,
  BackHandler,
  LayoutAnimation,
} from 'react-native'
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context'
import PropTypes from 'prop-types'
import PagerView from 'react-native-pager-view'
import WebView from 'react-native-webview'
import Permissions, { RESULTS } from 'react-native-permissions'
import { isArray, isEmpty } from 'lodash'
import ContentLoader, { Rect } from 'react-content-loader/native'

import {
  Icon,
  // VFButton,
  VFText,
  VFScreen,
  ErrorScreen
} from '@vfgroup-oneplatform/foundation/Components'
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'


import Timeline from '../../Components/Timeline'
import VfText from '../../Components/VfText'
import HorizontalLine from '../../Components/HorizontalLine'
import Modal from '../../Components/Modal'
import Card from '../../Components/Card'
import DateStep from '../../Components/DateStep'
import SelectGroup from '../../Components/SelectGroup'
import CameraStep from '../../Components/CameraStep'
import VFButton from '../../Components/VFButton'

import BundleList from '../../Components/BundleList/BundleList'

import PersonalForm from '../../Components/PesonalForm/PersonalForm'

import MigrationLottie from '../../Components/MigrationLottie'

import images from '../../Themes/Images'
import { getThemeImages } from '../../Themes'
import _Modal from 'react-native-modal'

import styles, {
  timelineTitleProps,
} from './RenewalsFix.Styles'

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get('window')


console.error = () => null

const MODAL_TYPES = {
  success: 'success',
  proccessing: 'proccesssing',
  error: 'error',
  idError: 'idError',
  cameraError: 'cameraError'
}


function Id({
  inputRef,
  accountInfo,
  isNameError,
  checkName,
  isSurnameError,
  checkSurname,
  isIdError,
  checkId,
  setNameError,
  setSurnameError,
  setIdError,
  isPurchase,
  isPurchaseID,
  openCameraErrorModal,
  setModalProps,
  theme
}) {

  const [isCameraOpen, setIsCameraOpen] = useState(false)
  const [modalSize, setModalSize] = useState(SCREEN_HEIGHT - 32)


  const {
    frontIdPhoto,
    setFrontIdPhoto,
    setFrontIdPhotoBase64,
    backIdPhoto,
    setBackIdPhoto,
    setBackIdPhotoBase64,
    selfie,
    setSelfie,
    setSelfieBase64,
  } = accountInfo || {}

  const getModalDimensions = dimensions => {
    setModalSize(dimensions.height)
  }

  const toggleCameraModal = () => {
    setIsCameraOpen(!isCameraOpen)
  }

  function getCamera() {
    return (
      <CameraStep
        toggleCameraModal={toggleCameraModal}
        frontIdPhoto={frontIdPhoto}
        setFrontIdPhoto={setFrontIdPhoto}
        backIdPhoto={backIdPhoto}
        setBackIdPhoto={setBackIdPhoto}
        selfie={selfie}
        setSelfie={setSelfie}
        setFrontIdPhotoBase64={setFrontIdPhotoBase64}
        setBackIdPhotoBase64={setBackIdPhotoBase64}
        setSelfieBase64={setSelfieBase64}
      />
    )
  }

  const checkPermissions = () => {
    setIsCameraOpen(true)
  }


  const themeImages = getThemeImages(theme.name)

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <>
        <View>
          <VFText
            i18nKey="renewals_id_step_title"
            style={styles.stepTitle}
          />
          <VFText
            i18nKey="renewals_id_step_desc"
            style={styles.stepDesc(theme)}
          />
        </View>
        <Card
          contentContainerStyle={styles.idContainer}
          style={styles.idCardStyle}
          theme={theme}
        >
          <View style={styles.idTextContainer}>
            <Icon
              name={themeImages.idIcon}
              type="image"
              size={40}
              resizeMode="contain"
            />
            <View style={styles.idText}>
              <VFText
                i18nKey="renewals_my_id"
                style={styles.stepDesc(theme)}
              />
              <VFText
                i18nKey="renewals_id_card_subtitle"
                style={styles.titleOfferStyle(theme)}
              />
            </View>
          </View>
          <HorizontalLine style={styles.line(theme)} />
          <VFText
            i18nKey="renewals_id_explaination_text"
            style={styles.explanationText}
          />
          <VFButton
            type="primary"
            title={(accountInfo?.frontIdPhoto && accountInfo?.backIdPhoto && accountInfo?.selfie) ? 'renewals_id_uploaded_photos' : 'renewals_take_id'}
            style={styles.btnStyle}
            onPress={checkPermissions}
            disabled={accountInfo?.frontIdPhoto && accountInfo?.backIdPhoto && accountInfo?.selfie}
          />
          <HorizontalLine style={styles.line(theme)} />
          <PersonalForm
            inputRef={inputRef}
            accountInfo={accountInfo}
            checkId={checkId}
            idError={isIdError}
            setIdError={setIdError}
            isNameError={isNameError}
            setNameError={setNameError}
            checkName={checkName}
            isSurnameError={isSurnameError}
            setSurnameError={setSurnameError}
            checkSurname={checkSurname}
            isPurchase={isPurchase}
            isPurchaseID={isPurchaseID}
            theme={theme}

          />
        </Card>
        <_Modal
          isVisible={isCameraOpen}
          backdropOpacity={0.5}
          onSwipeComplete={() => toggleCameraModal()}
          onBackdropPress={() => toggleCameraModal()}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              height: 'auto',
              minWidth: '600px',
              maxWidth: '600px',
              backgroundColor: theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              borderRadius: "7px",
            }}
            onStartShouldSetResponder={() => true}>
            {getCamera()}
          </View>
        </_Modal>
      </>
    )
  }

  return (
    <>
      <View>
        <VFText
          i18nKey="renewals_id_step_title"
          style={styles.stepTitle}
        />
        <VFText
          i18nKey="renewals_id_step_desc"
          style={styles.stepDesc(theme)}
        />
      </View>
      <Card
        contentContainerStyle={styles.idContainer}
        style={styles.idCardStyle}
        theme={theme}
      >
        <View style={styles.idTextContainer}>
          <Icon
            name={themeImages.idIcon}
            type="image"
            size={40}
            resizeMode="contain"
          />
          <View style={styles.idText}>
            <VFText
              i18nKey="renewals_my_id"
              style={styles.stepDesc(theme)}
            />
            <VFText
              i18nKey="renewals_id_card_subtitle"
              style={styles.titleOfferStyle(theme)}
            />
          </View>
        </View>
        <HorizontalLine style={styles.line(theme)} />
        <VFText
          i18nKey="renewals_id_explaination_text"
          style={styles.explanationText}
        />
        <VFButton
          type="primary"
          title={(accountInfo?.frontIdPhoto && accountInfo?.backIdPhoto && accountInfo?.selfie) ? 'renewals_id_uploaded_photos' : 'renewals_take_id'}
          style={styles.btnStyle}
          onPress={checkPermissions}
          disabled={accountInfo?.frontIdPhoto && accountInfo?.backIdPhoto && accountInfo?.selfie}
        />
        <HorizontalLine style={styles.line(theme)} />
        <PersonalForm
          inputRef={inputRef}
          accountInfo={accountInfo}
          checkId={checkId}
          idError={isIdError}
          setIdError={setIdError}
          isNameError={isNameError}
          setNameError={setNameError}
          checkName={checkName}
          isSurnameError={isSurnameError}
          setSurnameError={setSurnameError}
          checkSurname={checkSurname}
          isPurchase={isPurchase}
          isPurchaseID={isPurchaseID}
          theme={theme}
        />
      </Card>
      <_Modal
        isVisible={isCameraOpen}
        backdropOpacity={0.5}
        onSwipeComplete={() => toggleCameraModal()}
        onBackdropPress={() => toggleCameraModal()}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: '100%',
          maxWidth: '100%',
        }}
      >
        <View
          style={{
            height: '100%',
            minWidth: '100%',
            maxWidth: '100%',
            backgroundColor: theme.colors.quickActionGradientColors.secondary,
            margin: 'auto',
            padding: '20px',
            borderRadius: "7px",
          }}
          onStartShouldSetResponder={() => true}>
          {getCamera()}
        </View>
      </_Modal>
    </>
  )
}
Id.propTypes = {
  accountInfo: PropTypes.object,
  inputRef: PropTypes.object,
  image: PropTypes.string,
  setImage: PropTypes.func,
  checkId: PropTypes.func,
  isIdError: PropTypes.bool,
  checkName: PropTypes.func,
  isNameError: PropTypes.bool,
  checkSurname: PropTypes.func,
  isSurnameError: PropTypes.bool,
  setNameError: PropTypes.func,
  setIdError: PropTypes.func,
  setSurnameError: PropTypes.func,
  isPurchase: PropTypes.bool,
  openCameraErrorModal: PropTypes.func,
  setModalProps: PropTypes.func,
}

function RenewalFix({
  error,
  errorMessage,
  onClose,
  isContentLoading,
  hasInstallation,
  GetInternetOffers,
  GetTVOffers,
  isTvLoading,
  tvOffersError,
  offers,
  offersTV,
  selectedOffer,
  setSelectedOffer,
  selectTvOffer,
  selectTvAddOn,
  isVerifyLoading,
  isPurchase = true,
  accountInfo,
  isPurchaseID,
  verify,
  patchId,
  postIndividualLoading,
  getCustomerValidation,
  timeSlots,
  modems,
  tvResources,
  installationFee,
  selectedTimeSlot,
  setSelectedTimeSlot,
  selectedModem,
  setSelectedModem,
  deliveryAddresses,
  selectedDate,
  setSelectedDate,
  getTotalPrice,
  totalPrice,
  totalPriceError,
  totalPriceLoading,
  onConfirm,
  orderError,
  isOrderLoading,
  theme,
}) {

  const insets = useSafeAreaInsets()

  const themeImages = getThemeImages(theme.name)

  //Breakdown
  const [showBreakdown, setShowBreakdown] = useState(false)
  const [currentStep, setCurrentStep] = useState(0)
  const [retried, setRetried] = useState(false)
  const [tvPageSelected, setTvPageSelected] = useState(0)

  const showBreakdownCost = () => {
    LayoutAnimation.configureNext(
      LayoutAnimation.Presets.easeInEaseOut,
    )
    setShowBreakdown(!showBreakdown)
  }
  /** Information/Helper Modal */
  const [infoModal, setInfoModal] = useState({
    isOpen: false,
    type: 'normal',
    content: null,
  })

  const openInfoModal = (content, modalType = 'normal', isOpen = true) => {
    setInfoModal({
      isOpen: isOpen,
      type: modalType,
      content: content,
    })
  }

  const closeInfoModal = () =>
    setInfoModal({
      isOpen: false,
      content: null,
    })

  /** Success and Error Modal */
  const [modalProps, setModalProps] = useState({
    isOpen: false,
    type: 'normal',
  })
  const [modalState, setModalState] = useState({
    loading: false,
    type: null,
    title: null,
    desc: null,
    backLabel: null,
    back: null,
    backLoading: false,
    retryLabel: null,
    retry: null,
    retryLoading: false,
  })

  const openModal = (modalType = 'normal') => {
    setModalProps({
      isOpen: true,
      type: modalType,
    })
  }

  const closeModal = () => {
    setModalState({
      loading: false,
      type: null,
      title: null,
      desc: null,
      backLabel: null,
      back: null,
      backLoading: false,
      retryLabel: null,
      retry: null,
      retryLoading: false,
    })
    setModalProps({
      isOpen: false,
      type: 'normal',
    })
  }

  /** Camera permission error modal */
  const openCameraErrorModal = (openSettings, buttonTitle, title, desc) => {
    setModalState({
      loading: false,
      type: 'cameraError',
      title: title,
      desc: desc,
      backLabel: '',
      back: null,
      backLoading: false,
      retryLabel: buttonTitle,
      retry: openSettings,
      retryLoading: false,
    })
    setModalProps({
      isOpen: true,
      type: 'normal',
    })
  }

  /** show modal if there is an error getting offers  */
  useEffect(() => {
    if (error) {
      setModalState({
        loading: isContentLoading,
        type: 'error',
        title: 'renewals_default_error',
        desc: errorMessage || 'renewals_default_error',
        backLabel: 'renewal_go_back_button',
        back: onClose,
        backLoading: false,
        retryLabel: null,
        retry: null,
        retryLoading: false,
      })
      setModalProps({
        isOpen: error,
        type: 'full',
      })
    }
  }, [error, isContentLoading])

  //get internet offer if its purchase journey
  useEffect(() => {
    if (isPurchase) {
      if (pageSelected === 0) {
        GetInternetOffers()
      }
    }
  }, [])

  /** Viewpager reference to use @setPage function to change active page */
  const viewpagerRef = useRef(null)
  const viewpagerTvRef = useRef(null)
  const inputRef = useRef(null)
  const scrollRef = useRef()

  const [pageSelected, setPageSelected] = useState(0)

  /** Progress array for the timeline on each page */

  const DEFAULT_STEPS = [
    {
      type: 'current',
      title: 'renewals_offer_step',
    },
    {
      type: 'inactive',
      title: 'renewals_tv_step',
    },
    {
      type: 'inactive',
      title: 'renewals_id_step',
    },
    {
      type: 'inactive',
      title: 'renewals_installation_step',
    },
    {
      type: 'inactive',
      title: 'renewals_summary_step',
    },
  ]

  const NO_INSTALLATION_STEPS = [
    {
      type: 'current',
      title: 'renewals_offer_step',
    },
    {
      type: 'inactive',
      title: 'renewals_tv_step',
    },
    {
      type: 'inactive',
      title: 'renewals_id_step',
    },
    {
      type: 'inactive',
      title: 'renewals_summary_step',
    },
  ]

  const hasTVOffer = Object.keys(selectedOffer?.tvPlan || {}).length === 0 ? false : true

  const [progress, setProgress] = useState(hasInstallation ? (DEFAULT_STEPS) : NO_INSTALLATION_STEPS)

  useEffect(() => {
    if (!isPurchase && !hasTVOffer) {
      setProgress(prevProg => prevProg.filter(el => el.title !== 'renewals_tv_step'))
    }
  }, [])

  const updateProgress = index => {
    setProgress(prev => {
      prev.map((_, i) => {
        let status = 'inactive'
        if (index - i > 0) {
          status = 'active'
        } else if (index - i === 0) {
          status = 'current'
        }
        prev[i].type = status
      })
      return [...prev]
    })
  }

  const timeline = useMemo(() => (theme) => (
    <View style={styles.timelineContainer(theme)}>
      <Timeline
        items={progress}
        direction="horizontal"
        titleStyle={styles.timelineItemTitle}
        titleProps={timelineTitleProps}
        activeTitleStyle={styles.timelineActiveItemTitle(theme)}
        iconContainerStyle={styles.timelineIconContainer}
        isContentLoading={isContentLoading}
        ref={scrollRef}
        theme={theme}
      />
    </View>
  ), [currentStep])

  const goNext = (page) => {
    setCurrentStep(page)
    updateProgress(page)
  }


  const confirmOfferSelection = (offer) => {
    if (isPurchase) {
      setSelectedOffer(offer)
      GetTVOffers()
      goNext(1)
    } else {
      if (hasTVOffer) {
        setCurrentPage(1)
      } else {
        setCurrentPage(2)
      }
      updateProgress(1)
    }
  }

  const onVerificationError = (errorMessage) => {
    setModalState({
      loading: false,
      type: 'error',
      title: 'purchase_customer_verification_error_title',
      desc: errorMessage || 'purchase_customer_verification_error_message',
      backLabel: 'renewal_close_modal',
      back: onClose,
      backLoading: false,
      retryLabel: null,
      retry: null,
      retryLoading: false,
    })
    openModal('full')
  }

  const confirmTVPlanSelection = () => {
    if (isPurchase) {
      verify(() => goNext(2), (errorMessage) => onVerificationError(errorMessage))
    } else {
      goNext(2)
    }
  }

  const idStepSuccess = () => {
    getTotalPrice()
    if (hasInstallation) {
      goNext(3)
    } else {
      goNext(4)
    }

    scrollRef.current?.scrollToEnd?.()
  }

  const confirmInstallation = () => {
    goNext(4)
  }

  const renderModalContent = () => {
    let icon
    if (modalState.type === MODAL_TYPES.error || modalState.type === MODAL_TYPES.cameraError) {
      icon = images.warning
    } else {
      icon = images.tick
    }

    if (modalState.loading) {
      return null
    }
    if (!modalState.type) {
      return null
    }

    return (
      <View style={styles.modalContentContainerWraper}>
        <View style={styles.modalContentWraper2}>
          <Icon
            name={icon}
            size={modalProps.type === 'full' ? 120 : 54}
            type="image"
            resizeMode="contain"
          />
          <VfText
            weight="bold"
            size="h2"
            align="center"
            style={styles.verticalSpacing}
            i18nKey={modalState.title}
            color={theme.colors.textColor}
          />
          <VfText
            align="center"
            size="h5"
            i18nKey={modalState.desc}
            color={theme.colors.textColor}
          />
        </View>
        {MODAL_TYPES.cameraError !== modalState.type && <VFButton
          type="primary"
          title={modalState.backLabel || 'renewal_close_modal'}
          onPress={() => modalState.back ? modalState.back() : closeModal()}
          disabled={modalState.backLoading || modalState.retryLoading}
          isLoading={modalState.backLoading}
          loadingTitle="renewal_processing_action"
        />}
        {modalState.retry && (
          <VFButton
            type={MODAL_TYPES.cameraError === modalState.type ? 'primary' : 'secondary'}
            title={modalState.retryLabel || 'renewal_try_again'}
            onPress={modalState.retry}
            style={styles.secondaryButton}
            disabled={modalState.backLoading || modalState.retryLoading}
            isLoading={modalState.retryLoading}
            loadingTitle="renewal_processing_action"
          />
        )}
      </View>
    )
  }

  /** account info id step */
  const [isIdError, setIdError] = useState(false)
  const checkIdNumber = () => {
    if (accountInfo?.idFormat) {
      if (!accountInfo.idFormat.test(accountInfo?.id)) {
        setIdError(true)
      }
    }
  }
  const [isNameError, setNameError] = useState(false)
  const checkName = () => {
    if (accountInfo?.nameFormat) {
      if (!accountInfo.nameFormat.test(accountInfo?.name)) {
        setNameError(true)
      }
    }
  }
  const [isSurnameError, setSurnameError] = useState(false)
  const checkSurname = () => {
    if (accountInfo?.surnameFormat) {
      if (!accountInfo.surnameFormat.test(accountInfo?.surname)) {
        setSurnameError(true)
      }
    }
  }

  // useEffect(() => {
  //   const backAction = () => {
  //     resetStatusBar()
  //     return false
  //   }
  //   const backHandler = BackHandler.addEventListener(
  //     'hardwareBackPress',
  //     backAction
  //   )
  //   return () => backHandler.remove()
  // }, [])

  /** Order Confirmation */
  const openOrderConfirmModal = ({ type, message = '' }) => {
    if (!isOrderLoading) {
      setModalState({
        loading: false,
        type: type,
        title: type === 'error' ? 'renewals_order_completion_error' : 'renewals_order_completion_success',
        desc: message ? message : (type === 'error' ? 'renewals_order_completion_error_default_desc' : 'renewals_order_completion_success_default_desc'),
        backLabel: 'renewal_close_modal',
        back: onClose,
        backLoading: false,
        retryLabel: null,
        retry: null,
        retryLoading: false,
      })
      openModal('full')
    }
  }

  const onConfirmOrder = () => {
    onConfirm((modalData) => openOrderConfirmModal(modalData))
  }


  const renderInternetStep = () => {
    //List props depends on screenType ( isPurchase or not)
    const actSection = isContentLoading ? 0 : 1
    const listProps = {
      true: {
        showHeader: true,
        offers: offers,
        setSelectedOffer: () => { },
        activeSections: [actSection],
        containerStyles: styles.bundleListContainerStyle,
        bundleProps: {
          onButtonPress: (offer) => confirmOfferSelection(offer),
          buttonTitle: 'renewals_choose_bundle_button',
          disabled: isTvLoading
        },
      },
      false: {
        showHeader: true,
        offers: [selectedOffer],
        setSelectedOffer: () => { },
        activeSections: [actSection],
        containerStyles: styles.bundleListContainerStyle,
        bundleProps:
        {
          showButton: false,
          disabled: isTvLoading
        },
      },
    }
    return (
      <BundleList
        isLoading={isContentLoading}
        {...listProps[isPurchase]}
        theme={theme}
      />
    )
  }

  const renderTvSteps = () => {
    //List props depends on screenType ( isPurchase or not)

    const onTvPlanSelect = (tvOffer) => {
      selectTvOffer(tvOffer)
      if (isArray(tvOffer.addOns) && tvOffer.addOns.length >= 1) {
        setTvPageSelected(1)
      } else {
        confirmTVPlanSelection()
      }
    }
    const onTvAddOnSelect = (addOn) => {
      selectTvAddOn(addOn)
      confirmTVPlanSelection()
    }

    const listProps = {
      true: {
        offers: offersTV,
        setSelectedOffer: () => { },
        containerStyles: styles.bundleListContainerStyle,
        bundleProps: {
          onButtonPress: (tvOffer) => onTvPlanSelect(tvOffer),
          buttonTitle: 'bundle_choose_plan_button_label',
          disabled: isVerifyLoading
        },
      },
      false: {
        offers: [selectedOffer.tvPlan || {}],
        setSelectedOffer: () => { },
        activeSections: [1],
        containerStyles: styles.bundleListContainerStyle,
        bundleProps:
        {
          showButton: false,
          disabled: isVerifyLoading
        },
      },
    }

    const calculateWidth = () => {
      if (Dimensions.get('window').width > 700) {
        return `${(Dimensions.get('window').width - 300) * 0.8}px`
      }
      return `${(Dimensions.get('window').width - 40)}px`
    }

    if (tvPageSelected === 0) {
      return (
        <div style={{ paddingBottom: 100 }}>
          <VfText
            size="h3"
            style={styles.sectionTitle}
            isLoading={isTvLoading}
            i18nKey="renewals_title"
            weight="bold"
            color={theme.colors.textColor}
            loadingBackgroundColor={theme.colors.shimmerCenterColor}
            loadingForegroundColor={theme.colors.shimmerEdgesColor}
          />
          <VfText
            style={styles.sectionSubTitle}
            isLoading={isTvLoading}
            i18nKey='renewals_combine_offer'
            placeHolders={[selectedOffer?.title]}
            color={theme.colors.textColorTwo}
            loadingBackgroundColor={theme.colors.shimmerCenterColor}
            loadingForegroundColor={theme.colors.shimmerEdgesColor}
          />
          {(tvOffersError || offersTV.length === 0) && isPurchase ?
            <View style={{ flex: 1 }}>
              <ErrorScreen
                iconName=''
                text={retried ? 'renewals_tv_offer_error_retried' : 'renewals_tv_offer_error'}
                backgroundStyle={{ height: 'auto' }}
                iconStyle={styles.errorIconStyle}
                textStyle={styles.errorTextStyle}
                onPress={() => {
                  GetTVOffers()
                  setRetried(true)
                }}
              />
            </View> :
            <BundleList
              isLoading={isTvLoading}
              {...listProps[isPurchase]}
              theme={theme}
              isTV={true} />
          }

          {
            ((tvOffersError || offersTV.length === 0) && !retried && isPurchase) ? null : <>
              {isPurchase ? <VFButton
                type="primary"
                title="renewals_continue_without_tv_button"
                onPress={confirmTVPlanSelection}
                style={[{ marginTop: 6 }]}
                disabled={(isVerifyLoading || isTvLoading)}

              /> :
                <VFButton
                  type="primary"
                  title="renewals_continue_button"
                  onPress={confirmTVPlanSelection}
                  style={[{ marginTop: 6 }]}
                  disabled={(isVerifyLoading || isTvLoading)}
                />
              }
            </>
          }
        </ div>)
    }

    if (tvPageSelected === 1) {
      return (
        <ScrollView
          key="1"
          contentContainerStyle={styles.scrollContainer(insets.bottom)}
          showsVerticalScrollIndicator={false}
          nestedScrollEnabled={true}
        >
          <VfText
            size="h3"
            style={styles.sectionTitle}
            isLoading={isTvLoading}
            i18nKey="bundle_add_ons_label"
            weight="bold"
            loadingBackgroundColor={theme.colors.shimmerCenterColor}
            loadingForegroundColor={theme.colors.shimmerEdgesColor}
            color={theme.colors.textColor}
          />
          <VfText
            style={styles.sectionSubTitle}
            isLoading={isTvLoading}
            i18nKey="bundle_add_ons_extra_label"
            color={theme.colors.textColorTwo}
            loadingBackgroundColor={theme.colors.shimmerCenterColor}
            loadingForegroundColor={theme.colors.shimmerEdgesColor}
          />
          <BundleList
            offers={selectedOffer?.selectedTvOffer?.addOns || []}
            setSelectedOffer={() => { }}
            bundleProps={{
              onButtonPress: (addOn) => onTvAddOnSelect(addOn),
              buttonTitle: 'bundle_add_ons_button_label',
              disabled: isVerifyLoading,
            }}
            theme={theme}
            isTV={true}
          />

          <VFButton
            type="primary"
            title="renewals_next_button"
            onPress={confirmTVPlanSelection}
            style={{ marginTop: 6 }}
            disabled={(isVerifyLoading || isTvLoading)}
          />
        </ScrollView>
      )
    }
  }


  const TextLoader = () => {
    return (
      <ContentLoader
        speed={2}
        width={SCREEN_WIDTH - 32}
        height={70}
        backgroundColor={theme.colors.shimmerCenterColor}
        foregroundColor={theme.colors.shimmerEdgesColor}
        style={styles.textContentLoader}
      >
        <Rect x="4" y="5" rx="5" ry="5" width={100} height={15} />
        <Rect x="4" y="30" rx="5" ry="10" width={200} height={15} />
        <Rect x="4" y="55" rx="5" ry="15" width={200} height={15} />
      </ContentLoader>
    )

  }


  const renderSummary = () => {

    const myTvOffers = []
    if (isPurchase) {
      if (selectedOffer?.selectedTvOffer) myTvOffers.push(selectedOffer?.selectedTvOffer)
      if (selectedOffer?.selectedTvOffer?.selectedAddOn) myTvOffers.push(selectedOffer?.selectedTvOffer?.selectedAddOn)
    } else {
      if (!isEmpty(selectedOffer?.tvPlan)) {
        myTvOffers.push(selectedOffer?.tvPlan)
      }
    }

    const renderMyTv = () => {
      if (myTvOffers.length > 0) {
        return (
          <>
            <View style={styles.stepTitleContainer}>
              <VFText
                i18nKey="renewals_my_tv"
                style={styles.stepDesc(theme)}
              />
            </View>
            <BundleList
              containerStyles={[styles.bundleListContainerStyle, styles.summarySelectedContainer]}
              offerCardStyleContainer={styles.summarySelectedContainer}
              offers={myTvOffers}
              setSelectedOffer={() => { }}
              bundleProps={{
                showButton: false,
              }}
              theme={theme}
              isTV={true}
            />
          </>
        )
      }

    }

    const firstTimeBillPrice = totalPrice?.value + installationFee?.price + modems[selectedModem]?.price


    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <>
          <View>
            <View>
              <VFText
                i18nKey="renewals_summary_step_title"
                style={styles.stepTitle}
              />
              <VFText
                i18nKey="renewals_summary_step_desc"
                style={styles.stepDesc(theme)}
              />
            </View>
            <BundleList
              containerStyles={[styles.bundleListContainerStyle, styles.summarySelectedContainer, { paddingBottom: 0 }]}
              offerCardStyleContainer={[styles.summarySelectedContainer, { paddingBottom: 8 }]}
              offers={[selectedOffer]}
              setSelectedOffer={() => { }}
              bundleProps={{
                showButton: false,
              }}
              theme={theme}
            />
            {renderMyTv()}
            {/* Delivery part */}
            <View style={styles.stepTitleContainer}>
              <VFText
                i18nKey="renewals_summary_delivery_section_title"
                style={[styles.stepTitle, { marginTop: 0 }]}
              />
              <VFText
                i18nKey="renewal_summary_delivery_section_subtitle"
                style={styles.stepDesc(theme)}
              />
            </View>
            <SelectGroup
              options={deliveryAddresses}
              style={styles.modemSection}
              textStyle={{ fontSize: deliveryAddresses?.length <= 35 ? 18 : deliveryAddresses?.length <= 45 ? 16 : 14 }}
              selected={0}
              setSelected={() => { }}
            />
            {/* Total Cost part */}
            <View style={styles.summaryContainer(theme)}>
              {
                totalPriceLoading ? <TextLoader />
                  : <>
                    {totalPriceError ? <>
                      <View>
                        <ErrorScreen
                          iconName=''
                          text='renewals_summary_total_cost_error'
                          backgroundStyle={styles.errorScreenBackground(theme)}
                          iconStyle={styles.errorIconStyle}
                          textStyle={styles.errorTextStyle}
                          onPress={getTotalPrice}
                        />
                      </View>
                    </> : <>

                      <VFText
                        i18nKey="renewals_summary_step_total_cost"
                        style={[styles.stepTitle, styles.horizontalSpace]}
                      />
                      <VFText
                        i18nKey="renewals_summary_step_total_cost_subtitle"
                        style={[styles.stepDesc(theme), styles.horizontalSpace]}
                      />
                      <VFText
                        i18nKey="renewals_monthly"
                        style={[styles.stepTitle, , styles.horizontalSpace]}
                        placeHolders={[totalPrice?.value?.toString() + ' ' + ContentManager.translate(totalPrice?.unit)]}
                      />

                      {isPurchase && <>
                        <HorizontalLine style={styles.rowLine} />

                        <View style={[styles.detailContainer, styles.horizontalSpace]}>
                          <VFText
                            i18nKey="renewals_summary_step_first_bill"
                          />
                          <VFText
                            i18nKey={firstTimeBillPrice?.toString() + ' ' + ContentManager.translate(totalPrice?.unit) || ''}
                            style={[styles.costText]}
                          />
                        </View>
                        <View style={[styles.detailContainer, styles.horizontalSpace]}>
                          <VFText
                            i18nKey="renewals_summary_step_breakdown_monthly"
                          />
                          <VFText
                            i18nKey={totalPrice?.value?.toString() + ' ' + ContentManager.translate(totalPrice?.unit)}
                            style={styles.costText}
                          />
                        </View>

                        <HorizontalLine style={styles.rowLine} />
                        <TouchableOpacity style={[styles.detailContainer, styles.horizontalSpace]} onPress={showBreakdownCost}>
                          <VFText
                            i18nKey="renewals_summary_step_breakdown"
                            style={styles.costText}
                          />
                          <Icon
                            name={showBreakdown ? images.ic_chevron_up : images.ic_chevron_down}
                            type="image"
                            size={30}
                            resizeMode="contain"
                            style={styles.detailsBtnIcon}
                          />
                        </TouchableOpacity>
                        {/* Breakdown part */}
                        {showBreakdown && <View>
                          <VFText
                            i18nKey="renewals_summary_step_new_mobile_plan"
                            style={[styles.stepTitle, styles.horizontalSpace]}
                          />
                          <View style={styles.summaryBreakdownContainer(theme)}>
                            <VFText
                              i18nKey={selectedOffer?.title}
                              style={styles.costText}
                            />
                            {/* Monthly Payment */}
                            <View style={styles.detailContainer}>
                              <VFText
                                i18nKey="renewals_summary_step_monthly_payment"
                              />
                              <VFText
                                i18nKey={totalPrice?.value?.toString() + ' ' + ContentManager.translate(totalPrice?.unit)}
                                style={styles.costText}
                              />
                            </View>
                            {/* Modem Deposit */}
                            <View style={styles.detailContainer}>
                              <VFText
                                i18nKey="renewal_modem_deposit_label"
                              />
                              <VFText
                                i18nKey={modems[selectedModem]?.desc || ''}
                                style={styles.costText}
                              />
                            </View>
                            {/* Installation Fee */}
                            <View style={styles.detailContainer}>
                              <VFText
                                i18nKey="renewals_installation_fee"
                              />
                              <VFText
                                i18nKey={installationFee?.price?.toString() + ' ' + installationFee?.unit}
                                style={styles.costText}
                              />
                            </View>
                          </View>
                          <VFText
                            i18nKey="renewals_summary_step_discount_total_payment"
                            style={[styles.stepTitle, styles.horizontalSpace]}
                          />
                          {/* Total to pay part */}
                          <View style={[styles.detailContainer, styles.horizontalSpace]}>
                            <VFText
                              i18nKey="renewals_summary_step_first_bill"
                            />
                            <VFText
                              i18nKey={firstTimeBillPrice?.toString() + ' ' + ContentManager.translate(totalPrice?.unit) || ''}
                              style={[styles.costText]}
                            />
                          </View>
                          <View style={[styles.detailContainer, styles.horizontalSpace]}>
                            <VFText
                              i18nKey="renewals_summary_step_breakdown_monthly"
                            />
                            <VFText
                              i18nKey={totalPrice?.value?.toString() + ' ' + ContentManager.translate(totalPrice?.unit)}
                              style={styles.costText}
                            />
                          </View>
                        </View>}
                      </>}

                    </>}
                  </>
              }
              {/* Terms & Conditions */}
              <View style={[styles.linkContainer(theme), styles.horizontalSpace]}>
                <View style={styles.linkTextContainer}>
                  <VfText
                    i18nKey="terms_and_conditon_label"
                    style={styles.linkText}
                    color={theme.colors.textColorTwo}
                  />
                  <TouchableOpacity
                    onPress={() => {
                      openInfoModal(() => offerDetailsContent(ContentManager.translate(isPurchase ? 'purchase_terms_url' : 'renewals_terms_url'), 'renewals_terms_title'))
                    }}
                  >
                    <VfText
                      i18nKey="link_terms_and_policy_label"
                      style={[styles.linkText, styles.underLineText]}
                      color={theme.colors.textColorTwo}
                    />
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </View>
          <VFButton
            type="primary"
            title="renewals_confirm_button"
            onPress={onConfirmOrder}
            style={styles.lastButton}
            disabled={isOrderLoading || totalPriceError || totalPriceLoading}
            isLoading={isOrderLoading}
            loadingTitle="renewals_procesing"
          />
        </>
      )
    }

    return (
      <>
        <View style={styles.summaryContainerWrapper(theme)}>
          <View style={styles.stepTitleContainer}>
            <VFText
              i18nKey="renewals_summary_step_title"
              style={styles.stepTitle}
            />
            <VFText
              i18nKey="renewals_summary_step_desc"
              style={styles.stepDesc(theme)}
            />
          </View>
          <BundleList
            containerStyles={[styles.bundleListContainerStyle, styles.summarySelectedContainer]}
            offerCardStyleContainer={styles.summarySelectedContainer}
            offers={[selectedOffer]}
            setSelectedOffer={() => { }}
            bundleProps={{
              showButton: false,
            }}
            theme={theme}
          />
          {renderMyTv()}
          {/* Delivery part */}
          <View style={styles.stepTitleContainer}>
            <VFText
              i18nKey="renewals_summary_delivery_section_title"
              style={styles.stepTitle}
            />
            <VFText
              i18nKey="renewal_summary_delivery_section_subtitle"
              style={styles.stepDesc(theme)}
            />
          </View>
          <SelectGroup
            options={deliveryAddresses}
            style={styles.modemSection}
            textStyle={{ fontSize: deliveryAddresses?.length <= 35 ? 18 : deliveryAddresses?.length <= 45 ? 16 : 14 }}
            selected={0}
            setSelected={() => { }}
          />
          {/* Total Cost part */}
          <View style={styles.summaryContainer(theme)}>
            {
              totalPriceLoading ? <TextLoader />
                : <>
                  {totalPriceError ? <>
                    <View>
                      <ErrorScreen
                        iconName=''
                        text='renewals_summary_total_cost_error'
                        backgroundStyle={styles.errorScreenBackground(theme)}
                        iconStyle={styles.errorIconStyle}
                        textStyle={styles.errorTextStyle}
                        onPress={getTotalPrice}
                      />
                    </View>
                  </> : <>

                    <VFText
                      i18nKey="renewals_summary_step_total_cost"
                      style={[styles.stepTitle, styles.horizontalSpace]}
                    />
                    <VFText
                      i18nKey="renewals_summary_step_total_cost_subtitle"
                      style={[styles.stepDesc(theme), styles.horizontalSpace]}
                    />
                    <VFText
                      i18nKey="renewals_monthly"
                      style={[styles.stepTitle, , styles.horizontalSpace]}
                      placeHolders={[totalPrice?.value?.toString() + ' ' + ContentManager.translate(totalPrice?.unit)]}
                    />

                    {isPurchase && <>
                      <HorizontalLine style={styles.rowLine} />

                      <View style={[styles.detailContainer, styles.horizontalSpace]}>
                        <VFText
                          i18nKey="renewals_summary_step_first_bill"
                        />
                        <VFText
                          i18nKey={firstTimeBillPrice?.toString() + ' ' + ContentManager.translate(totalPrice?.unit) || ''}
                          style={[styles.costText]}
                        />
                      </View>
                      <View style={[styles.detailContainer, styles.horizontalSpace]}>
                        <VFText
                          i18nKey="renewals_summary_step_breakdown_monthly"
                        />
                        <VFText
                          i18nKey={totalPrice?.value?.toString() + ' ' + ContentManager.translate(totalPrice?.unit)}
                          style={styles.costText}
                        />
                      </View>

                      <HorizontalLine style={styles.rowLine} />
                      <TouchableOpacity style={[styles.detailContainer, styles.horizontalSpace]} onPress={showBreakdownCost}>
                        <VFText
                          i18nKey="renewals_summary_step_breakdown"
                          style={styles.costText}
                        />
                        <Icon
                          name={showBreakdown ? images.ic_chevron_up : images.ic_chevron_down}
                          type="image"
                          size={30}
                          resizeMode="contain"
                          style={styles.detailsBtnIcon}
                        />
                      </TouchableOpacity>
                      {/* Breakdown part */}
                      {showBreakdown && <View>
                        <VFText
                          i18nKey="renewals_summary_step_new_mobile_plan"
                          style={[styles.stepTitle, styles.horizontalSpace]}
                        />
                        <View style={styles.summaryBreakdownContainer(theme)}>
                          <VFText
                            i18nKey={selectedOffer?.title}
                            style={styles.costText}
                          />
                          {/* Monthly Payment */}
                          <View style={styles.detailContainer}>
                            <VFText
                              i18nKey="renewals_summary_step_monthly_payment"
                            />
                            <VFText
                              i18nKey={totalPrice?.value?.toString() + ' ' + ContentManager.translate(totalPrice?.unit)}
                              style={styles.costText}
                            />
                          </View>
                          {/* Modem Deposit */}
                          <View style={styles.detailContainer}>
                            <VFText
                              i18nKey="renewal_modem_deposit_label"
                            />
                            <VFText
                              i18nKey={modems[selectedModem]?.desc || ''}
                              style={styles.costText}
                            />
                          </View>
                          {/* Installation Fee */}
                          <View style={styles.detailContainer}>
                            <VFText
                              i18nKey="renewals_installation_fee"
                            />
                            <VFText
                              i18nKey={installationFee?.price?.toString() + ' ' + installationFee?.unit}
                              style={styles.costText}
                            />
                          </View>
                        </View>
                        <VFText
                          i18nKey="renewals_summary_step_discount_total_payment"
                          style={[styles.stepTitle, styles.horizontalSpace]}
                        />
                        {/* Total to pay part */}
                        <View style={[styles.detailContainer, styles.horizontalSpace]}>
                          <VFText
                            i18nKey="renewals_summary_step_first_bill"
                          />
                          <VFText
                            i18nKey={firstTimeBillPrice?.toString() + ' ' + ContentManager.translate(totalPrice?.unit) || ''}
                            style={[styles.costText]}
                          />
                        </View>
                        <View style={[styles.detailContainer, styles.horizontalSpace]}>
                          <VFText
                            i18nKey="renewals_summary_step_breakdown_monthly"
                          />
                          <VFText
                            i18nKey={totalPrice?.value?.toString() + ' ' + ContentManager.translate(totalPrice?.unit)}
                            style={styles.costText}
                          />
                        </View>
                      </View>}
                    </>}

                  </>}
                </>
            }
            {/* Terms & Conditions */}
            <View style={[styles.linkContainer(theme), styles.horizontalSpace]}>
              <View style={styles.linkTextContainer}>
                <VfText
                  i18nKey="terms_and_conditon_label"
                  style={styles.linkText}
                  color={theme.colors.textColorTwo}
                />
                <TouchableOpacity
                  onPress={() => {
                    openInfoModal(() => offerDetailsContent(ContentManager.translate(isPurchase ? 'purchase_terms_url' : 'renewals_terms_url'), 'renewals_terms_title'))
                  }}
                >
                  <VfText
                    i18nKey="link_terms_and_policy_label"
                    style={[styles.linkText, styles.underLineText]}
                    color={theme.colors.textColorTwo}
                  />
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
        <VFButton
          type="primary"
          title="renewals_confirm_button"
          onPress={onConfirmOrder}
          style={styles.lastButton}
          disabled={isOrderLoading || totalPriceError || totalPriceLoading}
          isLoading={isOrderLoading}
          loadingTitle="renewals_procesing"
        />
      </>
    )
  }

  const modemDetails = () => (
    <View style={styles.offerDetailsContainer}>
      <View style={styles.offerDetailsContent}>
        <VfText
          size="h5"
          weight="bold"
          isLoading={isContentLoading}
          i18nKey="renewal_details_modal_title"
          color={theme.colors.textColor}
        />
        <TouchableOpacity onPress={closeInfoModal}>
          <Icon
            source={themeImages.close}
            size={20}
            type="image"
            resizeMode="contain"
          />
        </TouchableOpacity>
      </View>
      {modems.map(item => (<View>
        <VfText
          size="h3"
          isLoading={isContentLoading}
          i18nKey={item.title}
          style={styles.verticalSpacingModem}
          color={theme.colors.textColor}
        />
        <View style={styles.inlineItems}>
          <Icon
            source={item.image}
            size={64}
            type="image"
            resizeMode="contain"
          />
          <View style={styles.leftDataModem}>
            <View style={styles.inlineItems}>
              <VfText
                isLoading={isContentLoading}
                i18nKey="renewal_modem_deposit"
                color={theme.colors.textColor}
              />
              <VfText
                weight="bold"
                isLoading={isContentLoading}
                i18nKey={item.desc}
                color={theme.colors.textColor}
              />
            </View>
            <HorizontalLine style={styles.modemLine} />
            <View style={styles.inlineItems}>
              <VfText
                isLoading={isContentLoading}
                i18nKey="renewal_modem_capacity"
                color={theme.colors.textColor}
              />
              <VfText
                weight="bold"
                isLoading={isContentLoading}
                i18nKey={item.capacity}
                color={theme.colors.textColor}
              />
            </View>
            <HorizontalLine style={styles.line} />
          </View>
        </View>
        <VfText
          isLoading={isContentLoading}
          i18nKey={item.note}
          style={styles.verticalSpacingModem}
          color={theme.colors.textColor}
        />
      </View>))}

      <VFButton
        type="primary"
        title="renewal_go_back_button"
        onPress={closeInfoModal}
        style={styles.button}
      />
    </View>
  )

  /** Ofer details & terms policy */
  const offerDetailsContent = (url, title = '') => (
    <View style={styles.offerDetailsContainer}>
      <View style={styles.offerDetailsContent}>
        <VfText
          size="h3"
          weight="bold"
          isLoading={isContentLoading}
          i18nKey={title}
          color={theme.colors.textColor}
        />
        <TouchableOpacity onPress={() => closeInfoModal()}>
          <Icon
            source={themeImages.close}
            size={25}
            type="image"
            resizeMode="contain"
          />
        </TouchableOpacity>
      </View>
      <View
        style={{ height: SCREEN_HEIGHT / 1.75 }}
        onStartShouldSetResponder={() => true}>
        <WebView
          source={{ uri: url }}
          style={styles.webView}
          startInLoadingState={true}
          renderLoading={() => (
            <View style={styles.lottieWrapper}>
              <MigrationLottie
                source={require('./loaderE60000.json')}
                style={styles.lottie}
              />
            </View>
          )}
        />
      </View>
      <VFButton
        type="primary"
        title="renewal_close_modal"
        onPress={() => closeInfoModal()}
        style={styles.button}
      />
    </View>
  )

  /** Id Verification */
  const idVerificationContent = ({ code = 400, message = '' }) => {
    const idMismatch = code === 404

    return (<View style={styles.offerDetailsContainer}>
      <View style={styles.offerDetailsContent}>
        <VfText
          size="h3"
          weight="bold"
          isLoading={isContentLoading}
          i18nKey="id_verification_title"
          color={theme.colors.textColor}
        />
        <TouchableOpacity onPress={closeInfoModal}>
          <Icon
            source={themeImages.close}
            size={25}
            type="image"
            resizeMode="contain"
          />
        </TouchableOpacity>
      </View>

      <View style={styles.idErrorContainer}>
        <Icon
          name={images.warning}
          size={100}
          resizeMode="contain"
        />
        <VFText
          i18nKey="id_verification_modal_title"
          style={styles.idStepDesc(theme)}
        />
        <VFText
          i18nKey={idMismatch ? "id_verification_modal_desc" : message}
          style={styles.idStepSubDesc(theme)}
        />
      </View>

      <VFButton
        type="primary"
        title="id_verification_close_modal"
        onPress={closeInfoModal}
        style={styles.button}
      />
    </View>
    )
  }

  const openIdVerificatonModal = (er) => openInfoModal(() => idVerificationContent(er))

  const confirmIdInfo = () => {
    if ((isPurchase && isPurchaseID) || !isPurchase) {
      getCustomerValidation(
        () => idStepSuccess(),
        (er) => onVerificationError(er?.message)
      )
    } else {
      patchId(
        () => idStepSuccess(),
        (er) => onVerificationError(er?.message)
      )
    }
  }

  const renderSteps = () => {
    if (currentStep === 0) {
      return (
        <View key="0" style={{ overflow: 'scroll', paddingBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : 20 }}>
          {renderInternetStep()}
          {!isPurchase && <VFButton
            type="primary"
            title="renewals_continue_button"
            onPress={confirmOfferSelection}
            style={[styles.lastButton]}
            disabled={offers.isNextDisabled}
          />}
        </View>
      )
    }

    if (currentStep === 1) {
      return (
        <View key="1" style={{ marginTop: 20, paddingBottom: Dimensions.get('window').width > 700 ? '15%' : null, overflow: 'scroll' }}>
          {renderTvSteps()}
        </View>
      )
    }

    if (currentStep === 2) {
      return (
        <View
          key='2'
          style={{ flex: 1, overflow: 'scroll', paddingBottom: Dimensions.get('window').width > 700 ? '25%' : 30 }}
        >
          <View style={styles.idContainer}>
            <Id
              inputRef={inputRef}
              accountInfo={accountInfo}
              isNameError={isNameError}
              setNameError={setNameError}
              checkName={checkName}
              isSurnameError={isSurnameError}
              setSurnameError={setSurnameError}
              checkSurname={checkSurname}
              isIdError={isIdError}
              setIdError={setIdError}
              checkId={checkIdNumber}
              isPurchase={isPurchase}
              insets={insets}
              isPurchaseID={isPurchaseID}
              openCameraErrorModal={openCameraErrorModal}
              setModalProps={setModalProps}
              theme={theme}
            />
          </View>
          <View style={{ zIndex: -1, position: 'relative' }}>
            <VFButton
              type="primary"
              title="renewals_next_button"
              loadingTitle="renewals_procesing"
              onPress={confirmIdInfo}
              style={styles.lastButton}
              isLoading={postIndividualLoading || isVerifyLoading}
              disabled={
                accountInfo?.isNextDisabled
                || isNameError
                || isSurnameError
                || isIdError
                || !accountInfo?.frontIdPhoto
                || !accountInfo?.backIdPhoto
                || !accountInfo?.selfie
              }
            />
          </View>

        </View>
      )
    }

    if (currentStep === 3) {
      return (
        <ScrollView
          key="3"
          contentContainerStyle={styles.scrollContainer(80)}
          showsVerticalScrollIndicator={false}
        >
          <DateStep
            selectedDate={selectedDate}
            // isLoading={isDatesLoading}
            onSelectDateAndTimePress={setSelectedDate}
            withTray={false}
          // {...date}
          />
          <SelectGroup
            options={timeSlots}
            style={styles.timeSlots}
            selected={selectedTimeSlot}
            setSelected={setSelectedTimeSlot}
          />
          {modems.length > 0 && <View>
            <View style={[styles.stepTitleContainer, { marginTop: 30 }]}>
              <View style={[styles.detailsBtn, styles.spaceBetweenItems]}>
                <VFText
                  i18nKey="renewals_modem_device"
                  style={styles.stepTitle}
                />
                <TouchableOpacity activeOpacity={0.5} style={styles.detailsBtn} onPress={() => openInfoModal(modemDetails)}>
                  <VFText
                    i18nKey="renewals_more_info"
                    style={styles.viewDetailText}
                  />
                  <Icon
                    name={images.info}
                    type="image"
                    size={20}
                    resizeMode="contain"
                    style={styles.detailsBtnIcon}
                  />
                </TouchableOpacity>
              </View>

              <VFText
                i18nKey="renewals_modem_device_description"
                style={styles.stepDesc(theme)}
              />
            </View>
            <SelectGroup
              options={modems}
              style={styles.modemSection}
              selected={selectedModem}
              setSelected={setSelectedModem}
            />
            <VFText
              i18nKey="renewals_modem_price_info"
              style={styles.modemPriceInfo}
            />

            {tvResources.length !== 0 && <>
              <View style={{ flexDirection: 'row' }}>
                {
                  tvResources.map(item => {
                    return (
                      <SelectGroup
                        options={[item]}
                        style={styles.modemSection}
                        selected={0}
                        setSelected={() => { }}
                      />
                    )
                  })
                }
              </View>
              <VFText
                i18nKey="renewals_tv_resources_info"
                style={styles.modemPriceInfo}
              />
            </>}

            <View style={styles.summaryContainer(theme)}>
              <VFText
                i18nKey="renewals_installation_fee"
                style={[styles.stepTitle, styles.horizontalSpace]}
              />
              <VFText
                i18nKey="renewals_installation_fee_description"
                style={[styles.stepDesc(theme), styles.horizontalSpace]}
              />
              <HorizontalLine style={styles.line(theme)} />

              <View>
                <View style={styles.installationContainer(theme)}>
                  <View style={styles.detailContainer}>
                    <VFText
                      i18nKey="renewals_installation_fee_first_time"
                      placeHolders={[selectedOffer?.contractPeriod]}
                      style={styles.timelineItemTitle}
                    />
                    <VFText
                      i18nKey={(installationFee?.price?.toString() + ' ' + installationFee?.unit) || ''}
                      style={styles.costText}
                    />
                  </View>
                </View>
              </View>
              <VFText
                i18nKey="renewals_fee_reallocation_info"
                style={[styles.reallocationInfo, styles.horizontalSpace]}
              />
            </View>
          </View>}
          <VFButton
            type="primary"
            title="renewals_next_button"
            onPress={confirmInstallation}
            style={[styles.lastButton, modems.length === 0 && { marginTop: 30 }]}
            disabled={(selectedTimeSlot === null) || (modems.length > 0 && selectedModem === null)}
          />
        </ScrollView>
      )
    }

    if (currentStep === 4) {
      return (
        <ScrollView
          key="4"
          contentContainerStyle={[styles.scrollContainer(insets.bottom)]}
          showsVerticalScrollIndicator={false}
        >
          {renderSummary()}
        </ScrollView>
      )
    }
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <VFScreen
        title="renewals_title"
        withSubHeader
        // withHeaderSpace
        onClose={onClose}
        subHeaderTitle={selectedOffer?.title || ' '}
        subHeaderTitleStyle={styles.titleText}
        subHeaderSubTitle={selectedOffer?.desc || ' '}
        subHeaderSubTitleStyle={styles.subtitleText}
        subHeaderAfterSubTitle={(!!selectedOffer?.desc && !!selectedOffer?.period) ? (' / ' + ContentManager.translate(selectedOffer?.period)) : ' '}
        subHeaderAfterSubTitleStyle={styles.subHeaderAfterSubTitleStyle}
        subHeaderDescription={!!selectedOffer?.periodValue ? ContentManager.translate('renewals_offer_valid', [selectedOffer?.periodValue, ContentManager.translate(selectedOffer?.period == 'Month' ? 'Months' : selectedOffer?.period)]) : ' '}
        renderDescriptionInfo={() => {
          return (
            <>
              {!isContentLoading && <TouchableOpacity
                style={styles.detailsBtn}
                onPress={() => {
                  openInfoModal(() => offerDetailsContent(ContentManager.translate(isPurchase ? 'purchase_more_info_url' : 'renewals_more_info_url'), 'renewals_view_details'))
                }}
              >
                <VfText
                  i18nKey="renewals_view_details_button"
                  style={styles.viewDetailText}
                  isLoading={isContentLoading}
                  size='footnote'

                />
                <Icon
                  name={images.details}
                  type="image"
                  size={20}
                  resizeMode="contain"
                  style={styles.detailsBtnIcon}

                />
              </TouchableOpacity>}
            </>
          )
        }}
      >
        {timeline(theme)}

        <View style={[styles.screenWrapper, { paddingHorizontal: '10%' }]}>
          {renderSteps()}
        </View>

        <_Modal
          isVisible={infoModal.isOpen}
          backdropOpacity={0.5}
          onSwipeComplete={() => closeInfoModal()}
          onBackdropPress={() => closeInfoModal()}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}>
          <View
            style={{
              height: 'auto',
              minWidth: '600px',
              maxWidth: '600px',
              backgroundColor: theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              borderRadius: "7px",
            }}
            onStartShouldSetResponder={() => true}>
            {infoModal.content?.()}
          </View>
        </_Modal>

        <_Modal
          isVisible={modalProps.isOpen}
          backdropOpacity={0.5}
          onSwipeComplete={() => {
            modalState.back?.()
            closeModal()
          }
          }
          onBackdropPress={() => {
            modalState.back?.()
            closeModal()
          }
          }
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}>
          <View
            style={{
              height: 'auto',
              minWidth: '600px',
              maxWidth: '600px',
              backgroundColor: theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              borderRadius: "7px",
            }}
            onStartShouldSetResponder={() => true}>
            {renderModalContent()}
          </View>
        </_Modal>
      </VFScreen>
    )
  }


  return (
    <VFScreen
      title="renewals_title"
      withSubHeader
      onClose={onClose}
      subHeaderTitle={selectedOffer?.title || ' '}
      subHeaderTitleStyle={styles.titleText}
      subHeaderSubTitle={selectedOffer?.desc || ' '}
      subHeaderSubTitleStyle={styles.subtitleText}
      subHeaderAfterSubTitle={(!!selectedOffer?.desc && !!selectedOffer?.period) ? (' / ' + ContentManager.translate(selectedOffer?.period)) : ' '}
      subHeaderAfterSubTitleStyle={styles.subHeaderAfterSubTitleStyle}
      subHeaderDescription={!!selectedOffer?.periodValue ? ContentManager.translate('renewals_offer_valid', [selectedOffer?.periodValue, ContentManager.translate(selectedOffer?.period == 'Month' ? 'Months' : selectedOffer?.period)]) : ' '}
      renderDescriptionInfo={() => {
        return (
          <>
            {!isContentLoading && <TouchableOpacity
              style={styles.detailsBtn}
              onPress={() => {
                openInfoModal(() => offerDetailsContent(ContentManager.translate(isPurchase ? 'purchase_more_info_url' : 'renewals_more_info_url'), 'renewals_view_details'))
              }}
            >
              <VfText
                i18nKey="renewals_view_details_button"
                style={styles.viewDetailText}
                isLoading={isContentLoading}
                size='footnote'

              />
              <Icon
                name={images.details}
                type="image"
                size={20}
                resizeMode="contain"
                style={styles.detailsBtnIcon}

              />
            </TouchableOpacity>}
          </>
        )
      }}
    >
      <View style={{ flex: 0.1, zIndex: 9 }}>
        {timeline(theme)}
      </View>

      <View style={[styles.screenWrapper, { padding: 20, paddingBottom: 150, overflow: 'scroll', zIndex: 1 }]}>
        {renderSteps()}
      </View>
      <Modal
        visible={infoModal.isOpen}
        close={() => closeInfoModal()}
        type={infoModal.type}
        contentContainerStyle={styles.modal(theme, insets)}
      >
        {infoModal.content?.()}
      </Modal>

      <Modal
        visible={modalProps.isOpen}
        close={() => {
          modalState.back?.()
          closeModal()
        }}
        type={modalProps.type}
        contentContainerStyle={styles.modal(theme, insets)}
      >
        {renderModalContent()}
      </Modal>
    </VFScreen>
  )
}

RenewalFix.defaultProps = {
  hasInstallation: true,
  theme: {
    name: 'light',
    colors: LightThemeColors,
  }
}

RenewalFix.propTypes = {
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  onClose: PropTypes.func,
  isContentLoading: PropTypes.bool,
  hasInstallation: PropTypes.bool,
  GetInternetOffers: PropTypes.func,
  GetTVOffers: PropTypes.func,
  isTvLoading: PropTypes.bool,
  tvOffersError: PropTypes.bool,
  offers: PropTypes.arrayOf(PropTypes.object),
  offersTV: PropTypes.arrayOf(PropTypes.object),
  selectedOffer: PropTypes.object,
  setSelectedOffer: PropTypes.func,
  selectTvOffer: PropTypes.func,
  selectTvAddOn: PropTypes.func,
  isVerifyLoading: PropTypes.bool,
  isPurchase: PropTypes.bool,
  accountInfo: PropTypes.object,
  isPurchaseID: PropTypes.bool,
  verify: PropTypes.func,
  patchId: PropTypes.func,
  postIndividualLoading: PropTypes.bool,
  getCustomerValidation: PropTypes.func,
  timeSlots: PropTypes.array,
  modems: PropTypes.array,
  tvResources: PropTypes.array,
  installationFee: PropTypes.object,
  selectedTimeSlot: PropTypes.number,
  setSelectedTimeSlot: PropTypes.func,
  selectedModem: PropTypes.number,
  setSelectedModem: PropTypes.func,
  deliveryAddresses: PropTypes.array,
  selectedDate: PropTypes.number,
  setSelectedDate: PropTypes.func,
  getTotalPrice: PropTypes.func,
  totalPrice: PropTypes.object,
  totalPriceError: PropTypes.bool,
  totalPriceLoading: PropTypes.func,
  onConfirm: PropTypes.func,
  orderError: PropTypes.bool,
  isOrderLoading: PropTypes.func,
  theme: PropTypes.objectOf({
    name: PropTypes.string,
    colors: PropTypes.object,
  })
}

export default withTheme(RenewalFix)
